import { render, staticRenderFns } from "./DistributionRights.vue?vue&type=template&id=8cefacd4&scoped=true"
import script from "./DistributionRights.vue?vue&type=script&lang=js"
export * from "./DistributionRights.vue?vue&type=script&lang=js"
import style0 from "./DistributionRights.vue?vue&type=style&index=0&id=8cefacd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cefacd4",
  null
  
)

export default component.exports